import React, { useState } from "react";
import { InputText } from "primereact/inputtext";
import { useFormik } from 'formik';
import * as Yup from "yup";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import LogoDark from '../../assets/imgs/logo2.png'
import LogoLight from '../../assets/imgs/logo_light.svg'
import "./auth.css"
import { useDispatch } from "react-redux";
import { handlePostRequest } from "../../services/PostTemplate";

const ForgetPassword = () => {
    const [saveBtnLoading, setSaveBtnLoading] = useState(false);
    const history = useHistory();
    const dispatch = useDispatch();


    const validationSchema = Yup.object().shape({
        mobile: Yup.mixed().required("This field is required."),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            mobile: "",
        },

        onSubmit: async (data) => {
            setSaveBtnLoading(true);

            try {
                const response = await dispatch(handlePostRequest('api/user/otprequest', data, true, true));
                console.log('response', response)
                if (response?.status == 200) {
                    console.log(response)
                    history.push({
                        pathname: "./verify-otp",
                        state: {
                            mobile: data?.mobile,
                            fromForgotPassword: true
                        }
                    })
                }
                setSaveBtnLoading(false);
            }
            catch (error) {
                console.log(error)
            }
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <div className="flex login-main-body align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
                    <div className="login-div-border">
                        <div className="w-full surface-card py-8 px-5 sm:px-6">
                            <div className="text-center mb-5">
                                <img src={true ? LogoLight : LogoDark} alt="Image" height="80" className="w-18rem mb-5" />
                                <div className="text-3xl font-medium mb-3" style={{ color: 'whitesmoke' }}>Find Account</div>
                                <span className="text-600 font-medium"></span>
                            </div>

                            <div className="login-div">
                                <div className="col-12">
                                    <div className="mb-4">
                                        <InputText id="mobile" type="tel" name="mobile" placeholder="Enter Phone No." value={formik.values.mobile} onChange={formik.handleChange} className="w-full mb-2 p-3" />
                                        {getFormErrorMessage("mobile")}
                                    </div>
                                </div>
                                <Button label="Next" loading={saveBtnLoading} type="submit" className="w-full mt-3 mb-3 p-3 text-xl" />

                                <p className="text-center text-white font-medium text-base cursor-pointer mt-4" onClick={() => history.push("/")}>Back to Login</p>
                            </div>
                        </div>

                    </div>
                </div>
            </form>
        </>

    );
};

export default ForgetPassword;
